import { render, staticRenderFns } from "./userMyCourse.vue?vue&type=template&id=62d68137&scoped=true&"
import script from "./userMyCourse.vue?vue&type=script&lang=js&"
export * from "./userMyCourse.vue?vue&type=script&lang=js&"
import style0 from "./userMyCourse.vue?vue&type=style&index=0&id=62d68137&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d68137",
  null
  
)

export default component.exports